export default __webpack_public_path__ + "static/1681-8e381c0bc6a8ee518690761b02b9ec09.gif";